import ProfileComments from './ProfileComments.component';

export default ProfileComments;
